<div class="modal-header">
  <h4 class="modal-title">Add/Edit Group</h4>
  <button ngbAutofocus class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" ngbAutofocus>
  <div class="form-group">
    <small class="text-muted">String ID (No Spaces)</small>
    <input class="form-control" [(ngModel)]="group.name" />
  </div>
  <div class="form-group">
    <small class="text-muted">Title</small>
    <input class="form-control" [(ngModel)]="group.description" />
  </div>
  <div class="form-group">
    <small class="text-muted">Description</small>
    <textarea name="description" id="description" rows="4" [(ngModel)]="group.snippet" class="form-control">{{ group.snippet }}</textarea>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" [disabled]="saving" (click)="save()">{{ saving ? "Saving..." : ("general.save" | translate) }}</button>
  <button type="button" class="btn btn-blank" (click)="activeModal.close('Close click')">{{ "general.close" | translate }}</button>
</div>
